import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
interface PageHeaderProps {
  title: string;
  subtitle: string;
  image: string;
  accentColor: string;
  accentGlow: string;
}
export function PageHeader({
  title,
  subtitle,
  image,
  accentColor,
  accentGlow
}: PageHeaderProps) {
  return <section className="relative h-[55vh] min-h-[400px] w-full flex flex-col justify-end overflow-hidden" data-id="element-258">
      <div className="absolute inset-0 z-0" data-id="element-259">
        <img src={image} alt={title} className="w-full h-full object-cover" data-id="element-260" />
        <div className="absolute inset-0 bg-black/60" data-id="element-261" />
        <div className="absolute inset-0 bg-gradient-to-t from-base via-base/50 to-transparent" data-id="element-262" />
      </div>
      <div className={`absolute bottom-0 left-0 w-full h-40 blur-[100px] opacity-20 pointer-events-none ${accentGlow}`} data-id="element-263" />
      <div className="relative z-10 max-w-7xl mx-auto w-full px-4 pb-16" data-id="element-264">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-265">
          <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-white transition-colors mb-8 text-sm" data-id="element-266">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-267" />
            Zurück zur Übersicht
          </Link>
        </motion.div>
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} className={`text-5xl md:text-7xl font-heading font-bold mb-4 ${accentColor}`} data-id="element-268">
          {title}
        </motion.h1>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.25
      }} className="text-xl md:text-2xl text-white/60 max-w-2xl" data-id="element-269">
          {subtitle}
        </motion.p>
      </div>
    </section>;
}